import { selectOrganizations } from "@overmap-ai/core"
import { memo } from "react"

import { useAppSelector } from "../../store"
import { CreateOrganizationView } from "../CreateOrganizationView/CreateOrganizationView"
import { OrganizationListView } from "./OrganizationListView"

export const OrganizationOnboarding = memo(() => {
	const organizations = useAppSelector(selectOrganizations)

	return organizations.length === 0 ? (
		<CreateOrganizationView />
	) : (
		<OrganizationListView organizations={organizations} />
	)
})
OrganizationOnboarding.displayName = "OrganizationOnboardingRoutes"
